import '../styles/globals.css'
import type { AppProps } from 'next/app'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <Component {...pageProps} />
    
  )
}

export default MyApp
